
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'
export function insertContacts (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contacts',
    method: 'POST',
    data: parameter
  })
}
export function updateContacts (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contacts',
    method: 'PUT',
    data: parameter
  })
}
export function deleteContacts (parameter) {
  return axios({
    url: sysInfo.apiRemote + '$/{model.name}/' + parameter,
    method: 'DELETE'
  })
}
export function getContactsList (parameter) {
  if (parameter.id) {
    parameter.proprietorId = parameter.id
  }
  return axios({
    url: sysInfo.apiRemote + '/proprietor/contacts',
    method: 'GET',
    params: parameter
  })
}
export function getContactsInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contacts',
    method: 'GET',
    params: parameter
  })
}
export function getContactsById (id) {
  return axios({
    url: sysInfo.apiRemote + '/proprietor/contacts',
    method: 'GET',
    params: {
      proprietorId: id
    }
  })
}
export function getDesignContactsById (id) {
  return axios({
    url: sysInfo.apiRemote + '/design/contacts',
    method: 'GET',
    params: {
      designId: id
    }
  })
}
